'use client';

import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import styles from './MobileMotto.module.css';

export default function MobileMotto({isVisible}) {
    const sceneRef = useRef(null);
    const groupRef = useRef(null);
    const headingsRef = useRef(null);

    useEffect(() => {
       const ctx = gsap.context(()=>{
        const group = groupRef.current;
        const headings = headingsRef.current;
        if (!group || !headings) return;
  const cardList = Array.from(group.querySelectorAll(`.${styles.card}`));
            const count = cardList.length;
            const image = group.querySelector(`.${styles.cardImg}`);
        // Wait a bit for DOM to be ready
          

            if (!image || count === 0) return;

            const radius = 180; // Mobile optimized radius

            // Create timeline with 3 second delay for loader
            const tl = gsap.timeline(isVisible ?{ delay: 7} :{delay:0}  );
            tl.to('.'+styles.content,{autoAlpha:1})
            // STEP 1: Cards fly in from sides
            tl.from(cardList, {
                x: (index) => {
                    return index % 2
                        ? -window.innerWidth / 2 - image.clientWidth * 4
                        : window.innerWidth / 2 + image.clientWidth * 4;
                },
                rotation: (index) => {
                    return index % 2 ? -90 : 90;
                },
                delay: (index) => {
                    return Math.floor(index / 2) * 0.1;
                },
                duration: 1,
                opacity: 0.8,
                scale: 5,
                ease: 'power4.out',
            });

            // STEP 2: Flip second half of images
            tl.set(cardList, {
                scale: (index) => {
                    return index > count / 2 - 1 ? -1 : 1;
                },
            });

            // STEP 3: Move cards up/down
            tl.to(cardList, {
                y: (index) => {
                    return (index >= Math.floor(count / 2) ? 1 : -1) * radius;
                },
                duration: 0.5,
                ease: 'power2.out',
            });

            // STEP 4: Set transform origin for rotation
            tl.set(cardList, {
                transformOrigin: `center ${radius + image.clientHeight / 2}px`,
                y: (index) => {
                    if (index >= Math.floor(count / 2)) {
                        return -radius;
                    }
                },
            });

            // STEP 5: Rotate into circle
            tl.to(cardList, {
                rotation: (index) => {
                    return index > count / 2 - 1
                        ? ((count - index - 1) * 360) / count
                        : (index * 360) / count;
                },
                opacity: 0.8,
                duration: 1,
                ease: 'power2.out',
            });

            // STEP 6: Fade in headings (overlapping with rotation)
  tl.from(headings, {
                opacity: 0,
                filter: 'blur(60px)',
                duration: 1.5,
            }, '<-=1');
            // STEP 7: Random card flips
            tl.to(cardList, {
                repeat: -1,
                duration: 2,
                onRepeat: () => {
                    gsap.to(cardList[Math.floor(Math.random() * count)], {
                        rotateY: '+=180',
                    });
                },
            });

            // STEP 8: Continuous rotation (overlapping with flips)
            tl.to(group, {
                rotation: 360,
                duration: 20,
                repeat: -1,
                ease: 'none',
            }, '<-=1.5');

       }) ;

        return () => {
            ctx.revert()
        };
    }, []);

    return (
        <div className={styles.content}>
            <div ref={sceneRef} className={styles.scene}>
                <div ref={groupRef} className={styles.group}>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/minci/1.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/zinc/1.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/testo/1.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/minci/2.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/zinc/2.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/testo/2.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/minci/1.webp)' }}></div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.cardImg} style={{ backgroundImage: 'url(https://longevity20155.sirv.com/zinc/1.webp)' }}></div>
                    </div>
                </div>
            </div>

            <div ref={headingsRef} className={styles.headings}>
                <h1 className={styles.headingsMain}>Experience</h1>
                <h1 className={styles.headingsMain}>Endurance</h1>
                <h5 className={styles.headingsSubtitle}>logvplus</h5>
            </div>
            
        </div>
    );
}
